<template>
  <div class="blue merida">
    <div ref="board" class="cg-board-wrap"></div> </br>
    <a @click="takeBack" class="button">Take back</a>
    
  </div>
</template>

<script>
import Chess from 'chess.js'
import {Chessground} from 'chessground'
import {uniques} from './Util.js'

export default {
  name: 'chessboard',
  props: {
    ai_difficulty: {
      type: String,
      default: 'Normal',
    },
    playerColor: {
      type: String,
      default: 'white',
    },
    fen: {
      type: String,
      default: '',
    },
    free: {
      type: Boolean,
      default: false,
    },
    showThreats: {
      type: Boolean,
      default: false,
    },
    onPromotion: {
      type: Function,
      default: () => 'q',
    },
  },
  data () {
    return {
      score: 0,
      ai_skill: '10',
      ai_depth: '6',
      scores:[],
      takingback: false
    }
  },
  watch: {
    ai_difficulty: function (ai_difficulty) {
      if (ai_difficulty == 'Easy') {
        this.ai_depth = '1'
        this.ai_skill = '0'
      } else if (ai_difficulty == 'Hard') {
        this.ai_depth = '10'
        this.ai_skill = '20'
      } else {
        this.ai_depth = '6'
        this.ai_skill = '10'
      }
    },
    fen: function (newFen) {
      this.fen = newFen
      this.loadPosition()
    },
    showThreats: function (st) {
      this.showThreats = st
      if (this.showThreats) {
        this.paintThreats()
      }
    },
  },
  methods: {
    takeBack() {
      this.takingback = true
      this.game.undo()
      this.game.undo()

      this.scores.pop()
      this.board.set({
        fen: this.game.fen()
      })
      //Brain start thinking
      this.uci('position startpos moves' + this.movesToUci(),'brain')
      this.uci('setoption name Skill Level value 20','brain') //not sure about skill
      this.uci("go depth 12",'brain')

      this.sendInfo()
    },
    uci(cmd, engine = 'ai') {
      if (engine == 'ai') {
        this.ai.postMessage(cmd)
      } else {
        this.brain.postMessage(cmd)
      }
    },
    movesToUci() {
        let moves = ''
        let history = this.game.history({verbose:true})
        for(let i = 0; i < history.length; ++i) {
          let move = history[i]
          moves += ' ' + move.from + move.to + (move.promotion ? move.promotion : '')
        }
        return moves
    },
    possibleMoves () {
      const dests = {}
      this.game.SQUARES.forEach(s => {
        const ms = this.game.moves({square: s, verbose: true})
        if (ms.length) dests[s] = ms.map(m => m.to)
      })
      return dests
    },
    possibleHandMoves (move) {
      let piece = this.game.get(move[1]).type
      let paintSquares = []
      const dests = {}
      this.game.SQUARES.forEach(s => {
        const ms = this.game.moves({square: s, verbose: true})
        if (ms.length && ms[0].piece == piece) {
          paintSquares.push({orig: ms[0].from, brush: 'yellow'})
          dests[s] = ms.map(m => m.to)
        }
      })
      this.board.setShapes(paintSquares)
      return dests
    },
    opponentMoves () {
      let originalPGN = this.game.pgn()
      let tokens = this.game.fen().split(' ')
      tokens[1] = tokens[1] === 'w' ? 'b' : 'w'
      tokens = tokens.join(' ')
      let valid = this.game.load(tokens)
      if (valid) {
        let moves = this.game.moves({verbose: true})
        this.game.load_pgn(originalPGN)
        return moves
      } else {
        return []
      }
    },
    toColor () {
      return (this.game.turn() === 'w') ? 'white' : 'black'
    },
    paintThreats () {
      let moves = this.game.moves({verbose: true})
      let threats = []
      moves.forEach(function (move) {
        threats.push({orig: move.to, brush: 'yellow'})

        if (move['captured']) {
          threats.push({orig: move.from, dest: move.to, brush: 'red'})
        }
        if (move['san'].includes('+')) {
          threats.push({orig: move.from, dest: move.to, brush: 'blue'})
        }
      })
      this.board.setShapes(threats)
    },
    calculatePromotions () {
      let moves = this.game.moves({verbose: true})
      this.promotions = []
      for (let move of moves) {
        if (move.promotion) {
          this.promotions.push(move)
        }
      }
    },
    isPromotion   (orig, dest) {
      let filteredPromotions = this.promotions.filter(move => move.from === orig && move.to === dest)
      return filteredPromotions.length > 0 // The current movement is a promotion
    },
    userPlay() {
      return (orig, dest) => {
        if (this.isPromotion(orig, dest)) {
          this.promoteTo = this.onPromotion()
        }
        this.game.move({from: orig, to: dest, promotion: this.promoteTo}) // promote to queen for simplicity
        this.board.set({
          fen: this.game.fen()
        })
        this.calculatePromotions()
        this.afterMove()
      };
    },
    afterMove () {
      if (this.isFinished() ) {
        return
      }
      this.aiNextMove()

      this.sendInfo()

    },
    aiNextMove() {
      this.uci('position startpos moves' + this.movesToUci())
      this.uci(`setoption name Skill Level value ${this.ai_skill}`)
      this.uci(`go depth ${this.ai_depth}`)
    },
    sendInfo() {
      if (this.showThreats) {
        this.paintThreats()
      }
      let threats = this.countThreats(this.toColor())
      threats['history'] = this.game.history()
      threats['fen'] = this.game.fen()
      threats['pgn'] = this.game.pgn()
      this.$emit('onMove', threats)
    },    
    isFinished() {
      if (this.game.in_checkmate()) {
        if (this.toColor() != this.playerColor) {
          this.$emit('onEnd', "YOU WIN")
        } else {
          this.$emit('onEnd', "YOU LOSE")
        }
        return true
      } else if (this.game.in_draw() ) {
        this.$emit('onEnd', "DRAW")
        return true
      } else if (this.game.in_stalemate() ) {
        this.$emit('onEnd', "STALEMATE")
        return true
      }
      return false

    },
    countThreats (color) {
      let threats = {}
      let captures = 0
      let checks = 0
      let moves = this.game.moves({verbose: true})
      if (color !== this.toColor()) {
        moves = this.opponentMoves()
      }

      if (moves.length === 0) {
        return null // It´s an invalid position
      }

      moves.forEach(function (move) {
        if (move['captured']) {
          captures++
        }
        if (move['san'].includes('+')) {
          checks++
        }
      })

      threats[`legal_${color}`] = uniques(moves.map(x => x.from + x.to)).length // promotions count as 4 moves. This remove those duplicates moves.
      threats[`checks_${color}`] = checks
      threats[`threat_${color}`] = captures
      threats[`turn`] = color
      return threats
    },
    loadPosition () { // set a default value for the configuration object itself to allow call to loadPosition()
      this.game.load(this.fen)
      this.board = Chessground(this.$refs.board, {
        fen: this.game.fen(),
        turnColor: this.toColor(),
        orientation: this.playerColor,
        movable: {
          color: this.playerColor,
          free: this.free,
          dests: this.possibleMoves(),
        },
      })
      if (this.playerColor == 'white') {
        this.board.set({
          movable: { events: { after: this.userPlay()} },
        })
      } else {
        this.board.set({
          movable: { events: { after: this.aiNextMove()} },
        })
      }
    },
    startAi() {
      this.ai = STOCKFISH();
      this.uci('uci')
      this.uci("ucinewgame")
      this.uci("isready")
      let self = this
      this.ai.onmessage = function(event) {
        if (self.toColor() == self.playerColor) {
          return
        }

        var line;
        if (event && typeof event === "object") {
            line = event.data;
        } else {
            line = event;
        }
        /// Ignore some output.
        if (line === "uciok" || line === "readyok" || line.substr(0, 11) === "option name") {
            return;
        }
        var match = line.match(/^bestmove ([a-h][1-8])([a-h][1-8])([qrbn])? .* (cp (-?\d+)|mate (-?\d+))/)

        /// Did the AI move?
        if(match) {

            let result = match[5]
            if (match[4].includes('mate')) {
              if (parseInt(match[6]) > 0) {
                result = 10000
              } else {
                result = -10000
              }
            }
            self.game.move({from: match[1], to: match[2], promotion: match[3]});

            self.calculatePromotions()

            let lastScore = self.scores.slice(-1)[0]
            let currentScore = parseInt(result) * -1
            let scoreDiff = currentScore - lastScore

            //Brain start thinking
            self.uci('position startpos moves' + self.movesToUci(),'brain')
            self.uci('setoption name Skill Level value 20','brain') //not sure about skill
            self.uci("go depth 12",'brain')

            setTimeout(function() {
              self.$emit('onMove', {pgn: self.game.pgn()})
              // self.board.move(match[1], match[2]);
              self.board.set({
                fen: self.game.fen()
              })
              if (self.isFinished() ) {
                return
              }
            }, 1000);
        }
      }
    },
    startBrain() {
      this.brain = STOCKFISH();
      this.uci('uci','brain')
      this.uci("ucinewgame",'brain')
      this.uci("isready",'brain')
      let self = this

      this.uci('position startpos moves' + this.movesToUci(),'brain')
      this.uci('setoption name Skill Level value 20','brain') //not sure about skill
      this.uci("go movetime 100",'brain')
      this.brain.onmessage = function(event) {
        var line;
        if (event && typeof event === "object") {
            line = event.data;
        } else {
            line = event;
        }
        /// Ignore some output.
        if (line === "uciok" || line === "readyok" || line.substr(0, 11) === "option name") {
            return;
        }

        var match = line.match(/^bestmove ([a-h][1-8])([a-h][1-8])([qrbn])? .* (cp (-?\d+)|mate (-?\d+))/)
        /// Did the brain chooses a move?
        if(match) {

          let result = match[5]
          if (match[4].includes('mate')) {
            if (parseInt(match[6]) > 0) {
              result = 10000
            } else {
              result = -10000
            }
          }
          if (self.toColor() == self.playerColor) {
            let lastScore = self.score
            self.score = parseInt(result)
            let scoreDiff = self.score - lastScore

            if (self.takingback) {
              lastScore = self.scores.slice(-2)[0] || 0
              self.score = self.scores.slice(-1)[0]
              scoreDiff = self.score - lastScore
              self.takingback = false
            } else {
              self.scores.push(self.score)
            }
            self.$emit('onScore', scoreDiff, self.score) // Negative bad, positive perfect

            setTimeout(function() {
              self.board.set({
                turnColor: self.toColor(),
                movable: {
                  color: self.toColor(),
                  dests: self.possibleHandMoves(match),
                  events: { after: self.userPlay()},
                }
              });
              self.calculatePromotions()
            }, 1000);
          }
        }
      };
    }
  },
  mounted () {
    this.startAi()
    this.startBrain()
    this.loadPosition()
  },
  created () {
    this.game = new Chess()
    this.board = null
    this.promotions = []
    this.promoteTo = 'q'
  },
}
</script>



// WEBPACK FOOTER //
// src/components/chessboard.vue